const actionsType = {
    GET_PRODUCTS: 'GET_PRODUCTS',
    GET_PRODUCTS_SKU: 'GET_PRODUCTS_SKU',
    GET_SEARCH_PRODUCTS: 'GET_SEARCH_PRODUCTS',
    GET_SHELF_PRODUCTS: 'GET_SHELF_PRODUCTS',
    GET_PRODUCT: 'GET_PRODUCT',

    UPDATE_ITEMS: 'update_items',

    GET_CART: 'GET_CART',
    ADD_ITEM_CART: 'ADD_ITEM_CART',
    REMOVE_ITEM_CART: 'REMOVE_ITEM_CART',
    REMOVE_ITEMS_CART: 'REMOVE_ITEMS_CART',
    CART_LOADING: 'CART_LOADING',
    CLEAR_CART: 'CLEAR_CART',
    UPDATE_CART: 'UPDATE_CART',
    SET_CUPON: 'SET_CUPON',
    SET_PAYMENT: 'SET_PAYMENT',
    SET_SHIPPING_DATA: 'SET_SHIPPING_DATA',
    SET_PROFILE_DATA: 'SET_PROFILE_DATA',
    GET_ORDER_INFO: 'GET_ORDER_INFO',
    SET_ORDER_INFO: 'SET_ORDER_INFO',

    SET_RECEIVER_DATA: 'SET_RECEIVER_DATA',
    GET_USER_INFO: 'get_user_info',
    GET_ACCOUNT_BANK_INFO: 'get_account_bank_info',

    GET_MESSAGES: 'get_messages_chat',
    SET_MESSAGE: 'update_messages_chat',

    MODAL: {
        VALIDATION_CODE_OPEN: 'validation_code_open',
        VALIDATION_CODE_CLOSE: 'validation_code_close',
        CRITERIA_SUBSTITUTION_OPEN: 'modal_criteria_substitution_open',
        CRITERIA_SUBSTITUTION_CLOSE: 'modal_criteria_substitution_close',
        DELIVERY_SELECTOR_OPEN: 'delivery_selector_open',
        DELIVERY_SELECTOR_CLOSE: 'delivery_selector_close',
        ADD_NOTES_OPEN: 'add_notes_open',
        ADD_NOTES_CLOSE: 'add_notes_close',
        FAILED_PAYMENT_OPEN: 'failed_payment_open',
        FAILED_PAYMENT_CLOSE: 'failed_payment_close',
        FAILED_PAYMENT_BANK_OPEN: 'failed_payment_bank_open',
        FAILED_PAYMENT_BANK_CLOSE: 'failed_payment_bank_close',
        ADD_TO_LIST_OPEN: 'add_to_list_open',
        ADD_TO_LIST_CLOSE: 'add_to_list_close',
        CONFIRMATION_OPEN: 'modal_confirmation_open',
        CONFIRMATION_CLOSE: 'modal_confirmation_close',
        PRODUCTS_CART_OPEN: 'cart_products_open',
        PRODUCTS_CART_CLOSE: 'cart_products_close',
        LOGIN_OPEN: 'login_open',
        LOGIN_CLOSE:'login_close',
        FEEDBACK_REGISTER_OPEN: 'modal_feedback_register_open',
        FEEDBACK_REGISTER_CLOSE: 'modal_feedback_register_close',
        PRODUCTS_LOST_OPEN: 'lost_products_open',
        PRODUCTS_LOST_CLOSE: 'lost_products_close',
        CREATE_NEW_LIST_OPEN: 'create_new_list_open',
        CREATE_NEW_LIST_CLOSE: 'create_new_list_close',
        PRODUCT_IN_CART_OPEN: 'modal_product_in_cart_open',
        PRODUCT_IN_CART_CLOSE: 'modal_product_in_cart_close',
        PASSWORD_OPEN: 'forgot_password_open',
        PASSWORD_CLOSE: 'forgot_password_close',
        DATE_DELIVERY_OPEN: 'modal_date_delivery_open',
        DATE_DELIVERY_CLOSE: 'modal_date_delivery_close',
        SCHOOLS_INSCRIPTION_OPEN: 'inscription_list_open',
        SCHOOLS_INSCRIPTION_CLOSE: 'inscription_list_close',
        REGISTER_OPEN: 'register_open',
        REGISTER_CLOSE: 'register_close',
        SUGGESTED_PRODUCT_OPEN: 'suggested_product_open',
        SUGGESTED_PRODUCT_CLOSE: 'suggested_product_close',
        PERSISTS_ADDRESS_OPEN: 'modal_persist_address_open',
        PERSISTS_ADDRESS_CLOSE: 'modal_persist_address_close',
        ADDRESS_OPEN: 'address_open',
        ADDRESS_CLOSE: 'address_close',
        EDIT_USER_OPEN: 'edit_user_open',
        EDIT_USER_CLOSE: 'edit_user_close',
        NEW_FEATURE_OPEN: 'new_feature_open',
        NEW_FEATURE_CLOSE: 'new_feature_close',
        ADD_CARDS_OPEN: 'add_cards_open',
        ADD_CARDS_CLOSE: 'add_cards_close',
        RECEIVER_DATA_OPEN: 'receiver_data_open',
        RECEIVER_DATA_CLOSE: 'receiver_data_close',
        UPDATE_CLIENT_OPEN: 'update_client_open',
        UPDATE_CLIENT_CLOSE: 'update_client_close',
        RESCHEDULE_ALERT_OPEN: 'reschedule_alert_open',
        RESCHEDULE_ALERT_CLOSE: 'reschedule_alert_close',
        RESCHEDULE_CONFIRM_OPEN: 'reschedule_confirm_open',
        RESCHEDULE_CONFIRM_CLOSE: 'reschedule_confirm_close',
        ORDER_CANCEL_SUCCESS_OPEN: 'order_cancel_success_open',
        ORDER_CANCEL_SUCCESS_CLOSE: 'order_cancel_success_close',
        TERMS_AND_CONDITIONS_OPEN: 'terms_and_conditions_open',
        TERMS_AND_CONDITIONS_CLOSE: 'terms_and_conditions_close',
        VALIDATION_CODE_CHECKOUT_OPEN: 'validation_code_checkout_open',
        VALIDATION_CODE_CHECKOUT_CLOSE: 'validation_code_checkout_close',
        NEWSLETTER_OPEN: 'modal_newsletter_open',
        NEWSLETTER_CLOSE: 'modal_newsletter_close',
        ADD_BANK_ACCOUNT_OPEN: 'modal_add_bank_account_open',
        ADD_BANK_ACCOUNT_CLOSE: 'modal_add_bank_account_close',
        FOOD_CERTIFICATES_OPEN: 'modal_food_certificates_open',
        FOOD_CERTIFICATES_CLOSE: 'modal_food_certificates_close',
        SHOP_TOGETHER_OPEN:  'modal_shop_together_open',
        SHOP_TOGETHER_CLOSE:  'modal_shop_together_close',
        DELIVERY_MODE_ADDRESS_OPEN: 'modal_delivery_mode_address_open',
        DELIVERY_MODE_ADDRESS_CLOSE: 'modal_delivery_mode_address_close',
        OPEN_TRACKING_ORDER: 'modal_tracking_open',
        CLOSE_TRACKING_ORDER: 'modal_tracking_close',
        ORDER_SUSPENSION_OPEN: 'modal_order_suspension_open',
        ORDER_SUSPENSION_CLOSE: 'modal_order_suspension_close',
        PersistentCart_OPEN: 'modal_persistentCart_open',
        PersistentCart_CLOSE: 'modal_persistentCart_close',

    },
    DRAWER: {
        SIMILAR_PRODUCTS_OPEN: 'drawer_similar_products_open',
        SIMILAR_PRODUCTS_CLOSE: 'drawer_similar_products_close',
        UPSELLING_OFFLINE_OPEN: 'drawer_upselling_offline_open',
        UPSELLING_OFFLINE_CLOSE: 'drawer_upselling_offline_close',
        UPSELLING_CONFIRMATION_OPEN: 'drawer_upselling_confirmation_open',
        UPSELLING_CONFIRMATION_CLOSE: 'drawer_upselling_confirmation_close',
        UPSELLING_CART_OPEN: 'drawer_upselling_cart_open',
        UPSELLING_CART_CLOSE: 'drawer_upselling_cart_close',
        BANK_ACCOUNT_OPEN: 'drawer_bank_account_open',
        BANK_ACCOUNT_CLOSE: 'drawer_bank_account_close',
        MINICART_OPEN: 'minicart_open',
        MINICART_CLOSE: 'minicart_close',
        QUICK_PURCHASE_OPEN: 'drawer_quick_purchase_open',
        QUICK_PURCHASE_CLOSE: 'drawer_quick_purchase_close',
        WRITER_REVIEWS_OPEN: 'drawer_writer_reviews_open',
        WRITER_REVIEWS_CLOSE: 'drawer_writer_reviews_close',
        WELCOME_PRIME_OPEN: 'drawer_welcome_prime_open',
        REGISTER_PRIME_OPEN: 'drawer_register_prime_open',
        REGISTER_PRIME_CLOSE: 'drawer_register_prime_close',
        WELCOME_PRIME_CLOSE: 'drawer_welcome_prime_close',
        INVITATION_PRIME_OPEN: 'drawer_prime_invitation_open',
        INVITATION_PRIME_CLOSE: 'drawer_prime_invitation_close',
        PAYMENT_METHOD_PRIME_OPEN: 'drawer_payment_method_prime_open',
        PAYMENT_METHOD_PRIME_CLOSE: 'drawer_payment_method_prime_close',
        RENOVATION_PRIME_OPEN: 'renovation_prime_open',
        RENOVATION_PRIME_CLOSE: 'renovation_prime_close',
        UPDATE_CLIENT_OPEN: 'client_update_open',
        UPDATE_CLIENT_CLOSE: 'client_update_close',
        ADDTO_LIST_OPEN: 'drawer_add_to_list_open',
        ADDTO_LIST_CLOSE: 'drawer_add_to_list_close',
        SCHEDULED_LIST_OPEN: 'drawer_scheduled_list_open',
        SCHEDULED_LIST_CLOSE: 'drawer_scheduled_list_close',
        PAYMENT_METHOD_OPEN: 'drawer_payment_method_open',
        PAYMENT_METHOD_CLOSE: 'drawer_payment_method_close',
        ADDRESS_OPEN: 'drawer_add_address_open',
        ADDRESS_CLOSE: 'drawer_add_address_close',
        LOGIN_OPEN: 'drawer_login_open',
        LOGIN_CLOSE:'drawer_login_close',
        PASSWORD_OPEN: 'drawer_forgot_password_open',
        PASSWORD_CLOSE: 'drawer_forgot_password_close',
        VALIDATION_CODE_OPEN: 'drawer_validation_code_open',
        VALIDATION_CODE_CLOSE: 'drawer_validation_code_close',
        REGISTER_OPEN: 'drawer_register_open',
        REGISTER_CLOSE: 'drawer_register_close',
        FEEDBACK_REGISTER_OPEN: 'drawer_feedback_register_open',
        FEEDBACK_REGISTER_CLOSE: 'drawer_feedback_register_close',

    },
    SET_SALES_CHANNEL: 'set_sales_channel',
    LOGGED_IN: 'logged_in',
    DELETE_CARD: 'delete_card',
    SELECT_CARD: 'select_card',
    CATALOG_URL_REDIRECT: 'catalog_url_redirect',
    CATALOG_CHANGE_PROPS: 'catalog_change_props',
    UPDATE_FAVORITES: 'update_favorites',
    SET_LOADING_FAVORITES: 'SET_LOADING_FAVORITES',
    CHECKOUT_ACTIVE_STEP : 'checkout_active_step',
    CHECKOUT_ENABLE_SUBMIT: 'checkout_enable_submit',
    CHECKOUT_SUBMIT: 'checkout_submit',
    TOTALIZER_LOADER: 'totalizer_loader',

    STORES: {
        SET_LOADING_RATING: 'set_loading_rating',
        UPDATE_RATING: 'update_rating'
    }
};


const pages = {
    menu: 11732,
    oldHome: 56,
    home: 2662,
    homeQA: 6492,
    school: 11140,
    cartUpselling: 19714,
    localities: 22134,
    friendlyUrls: 24725,
    offers: 446,
    benefits: 804,
    tyc: 917,
    frequentQuestions: 1001,
    securityPrivacy: 1093,
    contest: 1104,
    providers: 1659,
    ourServices: 1317,
    operations: 8548,
    operationsV2: 18721,
    registerForm: 12677,
    version: 16512,
    campaignCMS: 34823,
    updatellingCMS: 19714,
    commitmentsJumbo: 36729,
    newCommitmentsJumbo: 46971,
};

const ecommerce = {
    title : 'Jumbo',
    metaTitle : 'Jumbo.cl',
    whiteLabel: false,
    JumboTest: false,
}

const sizeProductImage = {
    mobile: 200,
    desktop: 360
}
const consumer = 'jumbo';
const defaultAccount = '';
const defaultSC = 11;
const defaultSeller = '1';
const feedbackRegister = 'SantaIsabel.cl'
const colorIcon = '#A4C735';

const header = {
    logoEcommerce : 'jumbo-icon-logo',
    nameEcommerce : 'Santa Isabel',
    linkEcommerce: 'https://www.santaisabel.cl',
    classNameEcommerce: 'santa-isabel',
    iconEcommerce : 'jumbo-icon-preheader-sisa',
    helpCenterLink : 'https://ayuda.jumbo.cl',
    needHelpLink : 'https://ayuda.jumbo.cl',
    searchCatUrl: 'https://jumbo.myvtex.com',
    whatsappPrime: 'https://wa.me/56941540961',
    paris: 'https://www.paris.cl',
    easy: 'https://www.easy.cl/tienda/',
    cencosudPoints: 'https://www.puntoscencosud.cl/puntos/'
}

const translateIcons = {
    'cat-electro-y-tecnologia': 'jumbo-icon-category-electro-y-tecnologia',
    'cat-jugueteria': 'jumbo-icon-category-jugueteria',
    'cat-libreria': 'jumbo-icon-category-libreria',
    'cat-mi-bebe': 'jumbo-icon-category-mi-bebe',
    'cat-deportes': 'jumbo-icon-category-deportes'
};

const translateFlag = {
    'Si': true,
    'No': false
}

const translateRegions ={
    'REGIÓN METROPOLITANA' :'Región Metropolitana',
    'V REGIÓN':'Región de Valparaíso',
    'IV REGIÓN':'Región de Coquimbo',
    'II REGIÓN':'Región de Antofagasta',
    'I REGIÓN':'Región de Tarapacá',
    'III REGIÓN':'Región de Atacama',
    'VI REGIÓN':'Región de O\'Higgins',
    'VII REGIÓN':'Región del Maule',
    'VIII REGIÓN':'Región del Bío Bío',
    'IX REGIÓN':'Región de La Araucanía',
    'X REGIÓN':'Región de Los Lagos',
    'XIV REGIÓN':'Región de Los Ríos',
    'XV REGIÓN':'Región de Arica y Parinacota'
}

const translateMethodStatus = {
    'store_pickup': 'Retiro en Tienda',
    'drive_through':'Click al Auto',
    'express_delivery':'Despacho a Domicilio',
    'delivery': 'Despacho a Domicilio'
}

const idPromoVtex = {
    'colaborator': 'f6b12174-a59e-477e-b5e8-843e1c0b308e',
}

const preheaderDropdown = [
    {
        icon: 'jumbo-icon-preheader-pay-credit',
        title: '<strong>Paga</strong> tu tarjeta',
        link: 'https://www.mitarjetacencosud.cl/TarjetaMasWEB/iniPagoPublico.do?utm_source=Jumbo_cl&utm_medium=Header&utm_campaign=pagar-ec'
    },
    {
        icon: 'jumbo-icon-preheader-advance',
        title: 'Simula un <strong>avance</strong>',
        link: 'https://www.tarjetacencosud.cl/TarjetaMasWEB/simularAvance.do?menu=publico&tipoAvance=avance&utm_source=Jumbo_cl&utm_medium=Header&utm_campaign=avance'
    },
    {
        icon: 'jumbo-icon-preheader-simulates',
        title: 'Simula un <strong>Súper Avance</strong>',
        link: 'https://www.tarjetacencosud.cl/TarjetaMasWEB/simularSAE.do?utm_source=Jumbo_cl&utm_medium=Header&utm_campaign=super-avance'
    },
    {
        icon: 'jumbo-icon-preheader-pay',
        title: 'Paga tu <strong>crédito de consumo</strong>',
        link: 'https://www.mitarjetacencosud.cl/TarjetaMasWEB/iniPagoPublicoCC.do?utm_source=Jumbo_cl&utm_medium=Header&utm_campaign=pagar-cc'
    },
    {
        icon: 'jumbo-icon-preheader-request-card',
        title: '<strong>Solicita</strong> tu tarjeta',
        link: 'https://www.mitarjetacencosud.cl/tarjeta-digital?utm_source=Jumbo_cl&utm_medium=Header&utm_campaign=emision-digital'
    },
]

const preheaderOurPrograms = [
    {
        icon: 'jumbo-icon-mundos-jumbo',
        title: 'Mundos Jumbo',
        link: 'https://mundosjumbo.cl/'
    },
    {
        icon: 'jumbo-icon-logo-compromisos',
        title: 'Compromisos Jumbo',
        link: 'https://www.jumbo.cl/compromisos-jumbo'
    },
    {
        icon: 'jumbo-icon-gift-card',
        title: 'Gift Card',
        link: 'https://www.giftcard.cl'
    },
]

const foodCertificates = {
    'Apto para APLV': {
        title: 'Apto para APLV (Alergia proteína leche vaca)',
        titleHtml: 'Apto para <br> <strong>APLV</strong>',
        icon: 'jumbo-icon-certificate-milk',
        description: 'Restringe derivados lácteos y de la soya, según indicaciones del MINSAL. Permite el Fosfato Tricálcico, Carbonato de Calcio y Colorante Caramelo, pues no son obtenidos de la leche.'
    },
    'Libre de Frutos Secos': {
        title: 'Libre de frutos secos',
        titleHtml: 'Libre de <br> <strong>Frutos Secos</strong>',
        icon: 'jumbo-icon-certificate-nuts',
        description: 'Restringe los frutos secos y sus derivados, tanto de los ingredientes como de las trazas.',
    },
    'Libre de Huevo': {
        title: 'Libre de Huevo',
        titleHtml: 'Libre de <br> <strong>Huevo</strong>',
        icon: 'jumbo-icon-certificate-egg',
        description: 'Restringe el alérgeno “huevo” (de gallina u otras aves) y sus derivados, tanto de los ingredientes como de las trazas.',
    },
    'Libre de Lactosa': {
        title: 'Libre de lactosa',
        titleHtml: 'Libre de <br> <strong>Lactosa</strong>',
        icon: 'jumbo-icon-certificate-milk',
        description: 'Permite sólo alimentos libres de lactosa y/o con sello "sin lactosa".',
    },
    'Libre de Maní': {
        title: 'Libre de Maní',
        titleHtml: 'Libre de <br> <strong>Maní</strong>',
        icon: 'jumbo-icon-certificate-peanut',
        description: 'Restringe el alérgeno “maní” y sus derivados, tanto de los ingredientes como de las trazas.',
    },
    'Libre de Mariscos': {
        title: 'Libre de mariscos y crustáceos',
        titleHtml: 'Libre de <strong>Mariscos</strong> <br> <strong> y Crustáceos</strong>',
        icon: 'jumbo-icon-certificate-seafood',
        description: 'Restringe el alérgeno “mariscos y crustáceos” y sus derivados, tanto de los ingredientes como de las trazas.',
    },
    'Libre de Nueces': {
        title: 'Libre de nueces',
        titleHtml: 'Libre de <br> <strong>Nueces</strong>',
        icon: 'jumbo-icon-certificate-walnuts',
        description: 'Restringe el alérgeno “nueces” de todo tipo, y sus derivados, tanto de los ingredientes como de las trazas.',
    },
    'Libre de Peces': {
        title: 'Libre de peces',
        titleHtml: 'Libre de <br> <strong>Peces</strong>',
        icon: 'jumbo-icon-certificate-fish',
        description: 'Restringe el alérgeno “pescado” y sus derivados, tanto de los ingredientes como de las trazas.',
    },
    'Libre de Soya': {
        title: 'Libre de soya',
        titleHtml: 'Libre de <br> <strong>Soya</strong>',
        icon: 'jumbo-icon-certificate-soy',
        description: 'Restringe el alérgeno “soya” y sus derivados, tanto de los ingredientes como de las trazas.',
    },
    'Libre de Sulfitos': {
        title: 'Libre de sulfitos',
        titleHtml: 'Libre de <br> <strong>Sulfitos</strong>',
        icon: 'jumbo-icon-certificate-sulphites',
        description: 'Restringe el alérgeno “sulfitos” y sus derivados, tanto de los ingredientes como de las trazas.',
    },
    'Vegano': {
        title: 'Vegano',
        titleHtml: '<strong>Vegano</strong>',
        icon: 'jumbo-icon-certificate-vegan',
        description: 'Se restringen todos los ingredientes, subproductos y derivados de origen animal.',
    },
    'Vegetariano': {
        title: 'Vegetariano',
        titleHtml: '<strong>Vegetariano</strong>',
        icon: 'jumbo-icon-certificate-vegetarian',
        description: 'Se restringen todos los ingredientes de origen animal. Se permiten subproductos tales como el huevo, leche, miel y sus derivados.',
    },
    'Orgánico': {
        title: 'Orgánico',
        titleHtml: '<strong>Orgánico</strong>',
        icon: 'jumbo-icon-certificate-organic',
        description: 'Producto certificado, elaborado bajo un sistema de manejo ecológico, en base a la conservación de los recursos naturales.',
    },
    'Libre de Trigo':{
        title: 'Alergia al trigo',
        titleHtml: 'Libre de <br> <strong>Trigo</strong>',
        icon: 'jumbo-icon-certificate-gluten',
        description: 'Solo serán aptos alimentos con sella "libre de gluten" o que se encuentren publicados en las listas de algún certificador reconocido',
    },
    'Libre de Azúcar añadida': {
        title: 'Libre de azúcar añadida',
        titleHtml: 'Libre de <br> <strong>Azúcar añadida</strong>',
        icon: 'jumbo-icon-certificate-added-sugar',
        description: 'Producto endulzado con ingredientes naturales o edulcorantes, no es endulzado con azúcar. “Si Ud es diabético recuerde revisar también  la cantidad de carbohidratos y azúcares totales”',
    },
    'Apto para Diabéticos': {
        title: 'Apto para Diabéticos',
        titleHtml: 'Apto para <br> <strong>Diabéticos</strong>',
        icon: 'jumbo-icon-certificate-sugar',
        description: 'Se restringen todos los azúcares refinados, junto con alimentos de alto índice glicémico',
    },
    'Libre de Gluten': {
        title: 'Libre de gluten (Alergia al trigo)',
        titleHtml: 'Libre de <br> <strong>Gluten</strong>',
        icon: 'jumbo-icon-certificate-gluten',
        description: 'Solo serán aptos alimentos con sello “libre de gluten” o que se encuentren publicados en las listas de algún certificador reconocido.',
    },
    'Halal': {
        title: 'Halal',
        titleHtml: '<strong>Halal</strong>',
        icon: 'jumbo-icon-certificate-halal',
        description: 'Se incluyen alimentos que posean el sello Halal, o que cumplan con lineamientos de algún certificador Halal reconocido.',
    },
    'Kosher': {
        title: 'Kosher',
        titleHtml: '<strong>Kosher</strong>',
        icon: 'jumbo-icon-certificate-koshe',
        description: 'Se incluyen alimentos que posean el sello Kosher, o que cumplan con lineamientos de algún certificador Kosher reconocido.',
    },
}


const productsSimulation = [
    {
        'idSku': '391',
        'quantidade': 1,
    },
    {
        'idSku': '11433',
        'quantidade': 1,
    },
    {
        'idSku': '25482',
        'quantidade': 1,
    },
    {
        'idSku': '5867',
        'quantidade': 1,
    },
    {
        'idSku': '5891',
        'quantidade': 1,
    },
    {
        'idSku': '5853',
        'quantidade': 1,
    },
    {
        'idSku': '277',
        'quantidade': 1,
    },
    {
        'idSku': '5901',
        'quantidade': 1,
    },
    {
        'idSku': '5906',
        'quantidade': 1,
    },
    {
        'idSku': '5872',
        'quantidade': 1,
    },
    {
        'idSku': '13591',
        'quantidade': 1,
    },
    {
        'idSku': '5869',
        'quantidade': 1,
    },
    {
        'idSku': '5881',
        'quantidade': 1,
    },
    {
        'idSku': '6870',
        'quantidade': 1,
    },
    {
        'idSku': '5876',
        'quantidade': 1,
    },
    {
        'idSku': '32333',
        'quantidade': 1,
    },
    {
        'idSku': '77375',
        'quantidade': 1,
    },
    {
        'idSku': '5870',
        'quantidade': 1,
    },
    {
        'idSku': '242',
        'quantidade': 1,
    },
    {
        'idSku': '62119',
        'quantidade': 1,
    },
    {
        'idSku': '5818',
        'quantidade': 1,
    },
    {
        'idSku': '45350',
        'quantidade': 1,
    },
    {
        'idSku': '32675',
        'quantidade': 1,
    },
    {
        'idSku': '9083',
        'quantidade': 1,
    },
    {
        'idSku': '75411',
        'quantidade': 1,
    },
    {
        'idSku': '69235',
        'quantidade': 1,
    }
]

const oldsDomain = [
    'nuevo.jumbo.cl',
    'checkout.jumbo.cl'
]

const deliveryMethods = {
    carPickup: 'seller-1-sla-ClickalAuto', // "Retiro en auto"
    storePickup: 'seller-1-sla-RetiroenTienda', // "Retiro en tienda"
    homeDelivery: 'seller-1-sla-DespachoaDomicilio', // "Despacho Agendado"
    expressDelivery: 'seller-1-sla-Express', // "Despacho Express"
}

const sectionsOrder = [
    'shelf_slider_destacados', 
    'short_banner', 
    'grid_image', 
    'small_banner_offer', 
    'shelf_tab_slider',
    'tabs_slider',
    'double_shelf_slider',
    'high_lights',
    'mun_jumbo',
    'offers_today',
    'offer_category',
    'recipe',
    'newrecipe',
    'vid_img_txt',
    'banners',
    'banner_with_timer',
    'island_image_and_text',
    'grid_2-2_video_image',
    'tabs_slider_v2',
    'small_informative',
    'grid_s_solid_funds'
];

const scheduledList = {
    scheduleStatus: {
        0: 'sin programar',
        1: 'programada',
        2: 'pausada'
    },
    scheduleFrequency: [
        { value: 1, label: 'Semanal' },
        { value: 2, label: 'Cada 2 semanas' },
        { value: 3, label: 'Mensual' },
    ],
    scheduleDeliveryDay:[
        { value: 1, label: 'Lunes' },
        { value: 2, label: 'Martes' },
        { value: 3, label: 'Miércoles' },
        { value: 4, label: 'Jueves' },
        { value: 5, label: 'Viernes' },
        { value: 6, label: 'Sábado' },
        { value: 7, label: 'Domingo' },
    ],
    scheduleStartDay: [
        { value: 1, label: 'Desde esta semana'},
        { value: 2, label: 'Próxima semana'},
        { value: 3, label: 'Próximo disponible'},
        { value: 4, label: 'Próximo mes'},
    ],
}

export {
    actionsType,
    pages,
    ecommerce,
    translateIcons,
    translateFlag,
    translateRegions,
    translateMethodStatus,
    idPromoVtex,
    foodCertificates,
    productsSimulation,
    consumer,
    defaultAccount,
    defaultSC,
    defaultSeller,
    oldsDomain,
    feedbackRegister,
    colorIcon,
    header,
    deliveryMethods,
    sectionsOrder,
    preheaderDropdown,
    sizeProductImage,
    scheduledList,
    preheaderOurPrograms
};

